export const APP_SESSION_TIMEOUT: number = 1000 * 60 * 10;
